import { useEmploymentTypes } from "@/hooks/useEmploymentTypes";
import { useWorkingOptions } from "./useWorkingOptions";
import useJobs from "@/hooks/useJobs";
import useTeam from "@/hooks/useTeam";
import { useSectors } from "@/hooks/useSectors";
import { useSkills } from "@/hooks/useSkills";

export const useJob = (url_slug) => {
  const job = useJobs().find((i) => i.url_slug === url_slug);
  const json = JSON.stringify(job.categories);

  const extractedWorkingOptions = job.categories.find((c) => c.name === "Working Options")?.values;

  const matchedWorkingOptions = useWorkingOptions().filter((e) =>
    extractedWorkingOptions?.some((option) => option.id === e.id)
  );

  return {
    ...job,
    consultant: useTeam().find((e) => json.includes(e.id)) ?? null,
    employment_types: useEmploymentTypes().filter((e) => json.includes(e.id)),
    working_options: matchedWorkingOptions, 
    sectors: useSectors().filter((t) => json.includes(t.id)),
    skills: useSkills().filter((b) => json.includes(b.id)),
  };
};


export default useJob;
